import { render, staticRenderFns } from "./InsightRecordsModal.vue?vue&type=template&id=0854ccd8&scoped=true&"
import script from "./InsightRecordsModal.vue?vue&type=script&lang=js&"
export * from "./InsightRecordsModal.vue?vue&type=script&lang=js&"
import style0 from "./InsightRecordsModal.vue?vue&type=style&index=0&id=0854ccd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854ccd8",
  null
  
)

export default component.exports